/**
 * 数值输出动画
 */
import fvAnimation from './fvAnimation';

export default class fvOutput extends fvAnimation {
    constructor(shape) {
        super(shape, 'fvOutput');
        this.isShowInvalid = shape.isShowInvalid;
        this.textInvalid = shape.textInvalid;
        this.sizeFunction = AsyncFunction('return ' + this.expression);
        this.shape = shape;
    }

    async run(textDom,isEnable,countLen) {
        var size = await this.executionScript(this.sizeFunction);
        if(size == -9999 || size == '__defaule' || size == undefined || isNaN(size)) {
            size = '...';
        }
        if(this.isShowInvalid) {//每个字体的无效值
            if(size == -9999 || size == '__defaule' || size == undefined || isNaN(size)) {
                size = this.textInvalid;
            } else if(size === '') {
                size = '...';
            }
        } else {
            if(size == -9999 || size == '__defaule' || size == undefined || isNaN(size)) {
                if(this.fvScript.system.$.jsonSysRootConfig.textInvalid != '') {
                    size = this.fvScript.system.$.jsonSysRootConfig.textInvalid;
                }
            } else if(size === '') {
                size = '...';
            }
        }
        if(typeof size == "boolean"){
            this.shape.innerText=size;
            textDom.lastElementChild.innerHTML = size;
        }else{
            this.shape.innerText=parseFloat(size).toFixed(countLen);
            textDom.lastElementChild.innerHTML = parseFloat(size).toFixed(countLen);
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvOutput.js